/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Step_ManageInputs */

const en_directory_submit_step_manage = /** @type {(inputs: Directory_Submit_Step_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage`)
};

const zh_directory_submit_step_manage = /** @type {(inputs: Directory_Submit_Step_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

/**
* | output |
* | --- |
* | "Manage" |
*
* @param {Directory_Submit_Step_ManageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_step_manage = /** @type {((inputs?: Directory_Submit_Step_ManageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Step_ManageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_step_manage(inputs)
	return zh_directory_submit_step_manage(inputs)
});
export { directory_submit_step_manage as "directory.submit.step_manage" }